var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-dialog',{attrs:{"dialog-title":"信息确认","center-dialog-visible":_vm.verifyVisible,"popup-width":'400px'},on:{"resetPopupData":_vm.resetPopupData,"submitPopupData":_vm.submitPopupData}},[_c('div',[_vm._v(" 确认后，易派客将开票信息推送至百望平台生成流水单，请提醒贵公司财务人员登录百望平台进行开票。 是否确认操作？ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }